module.exports = __webpack_public_path__ + "img/5.c9cada1.png";